import React from "react"

function SidebarItem(props) {
  let title = null
  if(props.title) {
    title = <h3>{props.title}</h3>
  }
  return (
    <div className="item boxshadow">
      {title}
      {props.children}
    </div>
  )
}

export default SidebarItem